import { Button } from "@universe/ui/components/button";
import { AnimatePresence, motion } from "framer-motion";
import { RefreshCcw } from "lucide-react";
import { useTranslations } from "next-intl";

interface RefreshButtonProps {
  isLoading: boolean;
  onRefresh: () => void;
}

export default function RefreshButton({
  isLoading,
  onRefresh,
}: RefreshButtonProps) {
  const tCommon = useTranslations("common");

  return (
    <Button
      variant="outline"
      size="icon"
      aria-label={tCommon("refresh")}
      onClick={(e) => {
        e.preventDefault();
        onRefresh();
      }}
    >
      <div className="relative size-4">
        <AnimatePresence mode="wait">
          {!isLoading && (
            <motion.div
              key="static"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.1 }}
              className="absolute inset-0"
            >
              <RefreshCcw className="size-4" />
            </motion.div>
          )}
        </AnimatePresence>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: isLoading ? 1 : 0 }}
          transition={{ duration: 0.1 }}
          className="absolute inset-0"
        >
          <RefreshCcw className="size-4 animate-spin-reverse" />
        </motion.div>
      </div>
    </Button>
  );
}
